import { render } from "./EditSuperAdminModal.vue?vue&type=template&id=e2a86f60&scoped=true"
import script from "./EditSuperAdminModal.vue?vue&type=script&lang=js"
export * from "./EditSuperAdminModal.vue?vue&type=script&lang=js"

import "./EditSuperAdminModal.vue?vue&type=style&index=0&id=e2a86f60&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a86f60"]])

export default __exports__